// Navigation des Moduls `connect` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul connect.
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'connect',
  title: 'Bar Connect',
});
